import { Box } from '@mui/material';
import React from 'react';

// Base Inner Container Scrollable component
function BaseScrollable({
	children,
	customHeight,
	defaultHeight,
	px,
	py,
}: {
	children: React.ReactNode;
	customHeight?: string;
	defaultHeight: string;
	px?: string | number;
	py?: string | number;
	backgroundColor?: string;
}) {
	const height = customHeight || defaultHeight;
	return (
		<Box
			sx={{
				height,
				overflowY: 'auto',
				display: 'block',
				'& ::-webkit-scrollbar': {
					display: 'none !important',
				},
				'&::-webkit-scrollbar': {
					display: 'none !important',
				},
				px,
				py,
			}}
		>
			{children}
		</Box>
	);
}

export default BaseScrollable;
